import React from 'react'
import CenteredLoadingSpinner from './CenteredLoadingSpinner'
import SubnavLoading from './SubnavLoading'

export default function AppLoading(): JSX.Element {
  return (
    <>
      <SubnavLoading />
      <CenteredLoadingSpinner />
    </>
  )
}
